// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__Rxlg7","tab":"Nav_tab__tlGyP","active":"Nav_active__QWBRF","icons":"Nav_icons__WmH5X"};